import React, {useState} from 'react';
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import moment from "moment/moment";
import {useForm} from "react-hook-form";
import CustomDatePicker from "../../base/components/forms/customDatePicker";
import FormHookInput from "../../air/airBooking/components/formHookInput";
import LoadingButton from "../../base/components/loadingButton";
import axios from "../../../helpers/axios";
import {Table} from "react-bootstrap";
import {RacoonGroupEditRoute} from "../../routesConstants";
import {Link} from "react-router-dom";
import numberFormat from "../../../helpers/numberFormat";

const UnregisterGroupCounterparty = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()

  const defaultVal ={
    startDate: moment().subtract(7, 'days').format('DD.MM.YYYY'),
    endDate: moment().format('DD.MM.YYYY')
  }
  const formController = useForm(defaultVal)
  const {register,
    getValues,
    handleSubmit,
    formState:{errors}} = formController

  const onSubmit = (data) =>{
    setLoading(true)
    axios.post('/api/racoon/revise/group/missedRecords', data)
      .then(({data})=>{
        console.log(data)
        setData(data.missedData)
      })
      .finally(setLoading.bind(false))
  }

  return (
    <Portlet>
      <PortletHeader title={'Неучтенные'} toolbar={<PortletHeaderToolbar>
        <form onSubmit={handleSubmit(onSubmit)} className={'d-flex align-items-center gap-2'}>
          <CustomDatePicker formController={formController}
                            label={"Дата c"}
                            value={defaultVal.startDate}
                            name={`startDate`}
                            rules={{required: true}}/>
          <CustomDatePicker formController={formController}
                            label={"Дата по"}
                            value={defaultVal.endDate}
                            name={`endDate`}
                            rules={{required: true}}/>
          <LoadingButton loading={loading} title={'Получить'}/>

        </form>

      </PortletHeaderToolbar>}/>
      {data && <PortletBody>
        <Table striped bordered>
          <thead>
          <tr>
            <th>Контрагент</th>
            <th>Период</th>
            <th>Билеты/ЕМД/Услуги/Оплаты</th>
            <th>Сумма</th>
            <th>Оплаты</th>
            <th>Итого</th>
          </tr>
          </thead>
          <tbody>
          {data.map((row,index)=>{
            return row.missedRecords.map((period,i)=>{
                return <tr key={i}>
                  {i === 0 ? <th>
                      {row.counterparty} {row.revises.map((r, i) => {
                      return <Link to={RacoonGroupEditRoute + r.id} key={i} target={'_blank'}>({r.range})</Link>
                    })}
                    </th> :
                    <th></th>}
                  <td>{period.range}</td>
                  <td>{period.tickets}/{period.emds}/{period.services}/{period.payments}</td>
                  <td>{numberFormat(row.saldo)}</td>
                  <td>{numberFormat(row.paymentsTotal)}</td>
                  <td>{numberFormat(row.saldo+row.paymentsTotal)}</td>
                </tr>
            })
          })}
          </tbody>
        </Table>
      </PortletBody>}

    </Portlet>
  );
};

export default UnregisterGroupCounterparty;
